import $ from 'jquery';

export const bindCopy2Clipboard = ($e) => {
    $e.on('click', () => {
        navigator.clipboard.writeText($e.attr('data-value'))
        .then(() => {
                $e.addClass('copied');
                setTimeout(() => {
                    $e.removeClass('copied');
                }, 1500);
            }, (err) => {
                console.error('Async: Could not copy text: ', err);
            });
    });
};